import React from "react";

export default function CartMenuIcon({ active, color = "#062D4B" }: any)
{
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66357 14.9998C5.74691 14.9998 5.00524 15.7498 5.00524 16.6665C5.00524 17.5832 5.74691 18.3332 6.66357 18.3332C7.58024 18.3332 8.33024 17.5832 8.33024 16.6665C8.33024 15.7498 7.58024 14.9998 6.66357 14.9998ZM1.66357 2.49984C1.66357 2.95817 2.03857 3.33317 2.49691 3.33317H3.33024L6.33024 9.65817L5.20524 11.6915C4.59691 12.8082 5.39691 14.1665 6.66357 14.1665H15.8302C16.2886 14.1665 16.6636 13.7915 16.6636 13.3332C16.6636 12.8748 16.2886 12.4998 15.8302 12.4998H6.66357L7.58024 10.8332H13.7886C14.4136 10.8332 14.9636 10.4915 15.2469 9.97484L18.2302 4.5665C18.5386 4.0165 18.1386 3.33317 17.5052 3.33317H5.17191L4.61357 2.1415C4.48024 1.84984 4.18024 1.6665 3.86357 1.6665H2.49691C2.03857 1.6665 1.66357 2.0415 1.66357 2.49984ZM14.9969 14.9998C14.0802 14.9998 13.3386 15.7498 13.3386 16.6665C13.3386 17.5832 14.0802 18.3332 14.9969 18.3332C15.9136 18.3332 16.6636 17.5832 16.6636 16.6665C16.6636 15.7498 15.9136 14.9998 14.9969 14.9998Z"
        fill={color}
      />
    </svg>

  );
}
